/* eslint-disable linebreak-style */
// auth
export const SIGNIN = '@@authentication/signIn';
export const SIGNOUT = '@@authentication/signOut';
export const SIGNOUT_SAGA = '@@authentication/signOutSaga';
export const SIGNINFAILURE = '@@authentication/signInFailure';
export const SIGNINSUCCESS = '@@authentication/signInSuccess';
export const SIGNUP = '@@authentication/signUp';
export const SIGNUPSUCCESS = '@@authentication/signUpSuccess';
export const SIGNUPFAILURE = '@@authentication/signUpFailure';
export const AUTH_CHALLENGE = '@@authentication/authChallenge';
export const CLEAR_AUTH_CHALLENGE = '@@authentication/clearAuthChallenge';

// user management
export const FETCH_USERS = '@@user/fetch-users';
export const SET_USERS = '@@user/set-users';
export const SET_USERS_FAILURE = '@@user/set-users-failure';
export const ADD_USER = '@@user/add-user';
export const ADD_USER_SUCCESS = '@@user/add-user-success';
export const ADD_USER_FAILURE = '@@user/add-user-failure';
export const UPDATE_USER = '@@user/update-user';
export const UPDATE_USER_SUCCESS = '@@user/update-user-success';
export const UPDATE_USER_FAILURE = '@@user/update-user-failure';
export const DELETE_USER = '@@user/delete-user';
export const DELETE_USER_SUCCESS = '@@user/delete-user-success';
export const DELETE_USER_FAILURE = '@@user/delete-user-failure';
export const BULK_ACTION_USERS = '@@user/bulk-action-users';
export const BULK_ACTION_USERS_SUCCESS = '@@user/bulk-action-users-success';
export const BULK_ACTION_USERS_FAILURE = '@@user/bulk-action-users-failure';
export const RESET_USER_PASSWORD = '@@user/reset-password';
export const RESET_USER_PASSWORD_SUCCESS = '@@user/reset-password-success';
export const RESET_USER_PASSWORD_FAILURE = '@@user/reset-password-failure';
export const TOGGLE_TWO_FACTOR = '@@user/toggle-two-factor';
export const TOGGLE_TWO_FACTOR_SUCCESS = '@@user/toggle-two-factor-success';
export const TOGGLE_TWO_FACTOR_FAILURE = '@@user/toggle-two-factor-failure';

// user access permissions
export const GET_USER_ACCESS = '@@user/get-user-access';
export const SET_USER_ACCESS = '@@user/set-user-access';
export const SET_USER_ACCESS_FAILURE = '@@user/set-user-access-failure';
export const UPDATE_USER_ACCESS = '@@user/update-user-access';
export const UPDATE_USER_ACCESS_SUCCESS = '@@user/update-user-access-success';
export const UPDATE_USER_ACCESS_FAILURE = '@@user/update-user-access-failure';
export const SAVE_USER_ACCESS = '@@user/save-user-access';
export const SAVE_USER_ACCESS_SUCCESS = '@@user/save-user-access-success';
export const SAVE_USER_ACCESS_FAILURE = '@@user/save-user-access-failure';
export const RESTORE_USER_ACCESS = '@@user/restore-user-access';
export const RESTORE_USER_ACCESS_SUCCESS = '@@user/restore-user-access-success';
export const RESTORE_USER_ACCESS_FAILURE = '@@user/restore-user-access-failure';

// user permissions after login
export const GET_USER_ACCESS_PERMISSIONS = '@@user/get-user-access-permissions';
export const SET_USER_ACCESS_PERMISSIONS = '@@user/set-user-access-permissions';
export const SET_USER_ACCESS_PERMISSIONS_FAILURE = '@@user/set-user-access-permissions-failure';

// project list
export const FETCH_PROJECTS = '@@/list-projects';
export const SET_PROJECTS = '@@user/set-projects';
export const SET_PROJECT_FAILURE = '@@user/set-project-failure';
export const SET_PROJECT_STATUS = '@@user/set-project-status';
export const SUBMIT_PROJECT = '@@user/submit-project';
export const UPDATE_PROJECT = '@@user/update-project';
export const SET_PROJECT_ADD = '@@user/set-update-add';
export const SET_PROJECT_UPDATE = '@@user/set-update-project';


// client list
export const FETCH_CLIENTS = '@@/list-clients';
export const SET_CLIENTS = '@@user/set-clients';
export const SET_CLIENT_FAILURE = '@@user/set-client-failure';
export const ADD_CLIENT = '@@client/add-client';
export const ADD_CLIENT_SUCCESS = '@@client/add-client-success';
export const ADD_CLIENT_FAILURE = '@@client/add-client-failure';


// phase list
export const FETCH_PHASES = '@@/list-clients';
export const SET_PHASES = '@@user/set-clients';
export const SET_PHASE_FAILURE = '@@user/set-client-failure';
export const ADD_PHASE = '@@client/add-client';
export const ADD_PHASE_SUCCESS = '@@client/add-client-success';
export const ADD_PHASE_FAILURE = '@@client/add-client-failure';

// weld data management
export const FETCH_WELD_DATA = '@@weld/fetch-weld-data';
export const SET_WELD_DATA = '@@weld/set-weld-data';
export const SET_WELD_DATA_FAILURE = '@@weld/set-weld-data-failure';
export const FETCH_WELD_PASSES = '@@weld/fetch-weld-passes';
export const SET_WELD_PASSES = '@@weld/set-weld-passes';
export const SET_WELD_PASSES_FAILURE = '@@weld/set-weld-passes-failure';
export const CLEAR_WELD_PASSES = '@@weld/clear-weld-passes';

// user table layout management
export const CREATE_UPDATE_USER_TABLE_LAYOUT = '@@user-table-layout/create-update-user-table-layout';
export const CREATE_UPDATE_USER_TABLE_LAYOUT_SUCCESS = '@@user-table-layout/create-update-user-table-layout-success';
export const CREATE_UPDATE_USER_TABLE_LAYOUT_FAILURE = '@@user-table-layout/create-update-user-table-layout-failure';
export const GET_ALL_USER_TABLE_LAYOUTS = '@@user-table-layout/get-all-user-table-layouts';
export const SET_ALL_USER_TABLE_LAYOUTS = '@@user-table-layout/set-all-user-table-layouts';
export const SET_ALL_USER_TABLE_LAYOUTS_FAILURE = '@@user-table-layout/set-all-user-table-layouts-failure';
export const GET_USER_TABLE_LAYOUT_BY_ID = '@@user-table-layout/get-user-table-layout-by-id';
export const SET_USER_TABLE_LAYOUT_BY_ID = '@@user-table-layout/set-user-table-layout-by-id';
export const SET_USER_TABLE_LAYOUT_BY_ID_FAILURE = '@@user-table-layout/set-user-table-layout-by-id-failure';
